import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-error.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../public/assets/fonts/PPEditorialNew-Ultralight-BF644b21500d0c0.otf%22,%22style%22:%22normal%22},{%22path%22:%22../public/assets/fonts/PPEditorialNew-UltralightItalic-BF644b214ff1e9b.otf%22,%22style%22:%22italic%22}],%22display%22:%22swap%22,%22variable%22:%22--font-serif%22}],%22variableName%22:%22ppEditorialNew%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'ppEditorialNew', 'ppEditorialNew Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
